// src/App.js
import React, { useMemo } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

import Main from "./pages/Main";
// import About from "./pages/About";
import Privasi from "./pages/Privasi";
import Kemaskini from "./pages/Kemaskini";
import Kerjaya from './pages/Kerjaya';
import EtvMain from "./pages/EtvMain";
import MalaysiaProduct from "./pages/MalaysiaProduct";
import NotFound from "./pages/NotFound";

import Footer from "./components/Footer";
import Header from "./components/Header";

import Tazkirah from "./pages/Tazkirah";

import MasjidPublicLayout from "./pages/MasjidPublicLayout";
import MasjidPublicHome from "./pages/MasjidPublicHome";
import MasjidKempen from "./pages/MasjidKempen";
import MasjidKempenDetail from "./pages/MasjidKempenDetail";
import KitabPage from "./pages/KitabPage";
import MasjidPage from "./pages/MasjidPage";
import Admin from "./pages/Admin";
import Asatizah from "./pages/Asatizah";
import KuliahSinglePage from "./pages/KuliahSinglePage";
import Demo from "./pages/Demo";



import useWebAnalytics from "./utils/useWebAnalytics";
import "./App.css";

const RESERVED = new Set([
  "about",
  "privasi",
  "kemaskini",
  "kerjaya",
  "pengenalan",
  "my",
  "etv",
  "tazkirah",
  "login",
  "daftar",
  "kitab",
  "masjid",
  "admin",
  "asatizah",
  "share",
  "demo",
  "l",
]);


function Layout() {
  const location = useLocation();
  const path = (location.pathname || "/").toLowerCase();
  useWebAnalytics();

  const segs = useMemo(
    () => path.split("?")[0].split("/").filter(Boolean),
    [path]
  );

  const isLoginPage = path === "/login";
  const isDaftarPage = path === "/daftar";
  const isTazkirahPage = path.startsWith("/tazkirah");
  const isDemoPage = path === "/demo";

  const isMasjidPublicRoute = segs.length > 0 && !RESERVED.has(segs[0]);
  const isMasjidPublicRouteL = segs[0] === "l" && segs.length > 1;

  // ✅ detect single kuliah page (dua format)
  const isKuliahSingle =
    (segs[0] === "l" && segs[2] === "k" && Boolean(segs[3])) ||   // /l/:slug/k/:k
    (segs.length >= 3 && segs[1] === "k" && Boolean(segs[2]));    // /:slug/k/:k

  const hideChrome =
    isLoginPage ||
    isDaftarPage ||
    isTazkirahPage ||
    isDemoPage ||
    isMasjidPublicRoute ||
    isMasjidPublicRouteL ||
    isKuliahSingle;

  return (
    <div className="App">
      {!hideChrome && <Header />}

      {/* ✅ ini penting: bagi main tahu ada header atau tak */}
      <main className={`${isDemoPage ? "" : "container"} ${hideChrome ? "no-header" : "with-header"}`}>
        <Routes>
          <Route path="/" element={<Main />} />
          {/* <Route path="/about" element={<About />} /> */}
          <Route path="/privasi" element={<Privasi />} />
          <Route path="/kemaskini" element={<Kemaskini />} />
          <Route path="/kerjaya" element={<Kerjaya />} />
          <Route path="/pengenalan" element={<Navigate to="/my" replace />} />
          <Route path="/my" element={<MalaysiaProduct />} />
          <Route path="/etv" element={<EtvMain />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/asatizah" element={<Asatizah />} />
          <Route path="/kitab" element={<KitabPage />} />
          <Route path="/kitab/:kitabId" element={<KitabPage />} />
          <Route path="/masjid" element={<MasjidPage />} />
          <Route path="/demo" element={<Demo />} />

          <Route path="/tazkirah/:slug" element={<Tazkirah />} />

          <Route path="/l/:slug/k/:k" element={<KuliahSinglePage />} />
          <Route path="/:slug/k/:k" element={<KuliahSinglePage />} />


          <Route path="/:slug" element={<MasjidPublicLayout />}>
            <Route index element={<MasjidPublicHome />} />
            <Route path="k/:k" element={<KuliahSinglePage />} />   {/* optional */}
            <Route path="kempen" element={<MasjidKempen />} />
            <Route path="kempen/:kempenId" element={<MasjidKempenDetail />} />
          </Route>


          <Route path="/l/:slug" element={<MasjidPublicLayout />}>
            <Route index element={<MasjidPublicHome />} />
            <Route path="k/:k" element={<KuliahSinglePage />} />   {/* ✅ TAMBAH INI */}
            <Route path="kempen" element={<MasjidKempen />} />
            <Route path="kempen/:kempenId" element={<MasjidKempenDetail />} />
          </Route>





          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {!hideChrome && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}
